/**
 * 初回クーポン ウェルカムモーダル
 * PASS COFFEE (passcoffee_rise/assets/pc-welcome-modal.js) からの移植・HOOP用に再実装。
 * - Tailwindクラス切替を .is-open / .is-visible のCSSクラス方式に置換
 * - フォーカストラップは Impulse の theme.a11y.trapFocus / removeTrapFocus を使用（無ければ素のfocus）
 * - ログイン中はそもそもセクションが描画されない（Liquidの {% unless customer %} で制御）
 */
(function () {
  function init() {
    var modal = document.querySelector('[data-wc-modal]');
    var floatWrap = document.querySelector('[data-wc-float-wrap]');
    var floatOpen = document.querySelector('[data-wc-float]');
    var floatHide = document.querySelector('[data-wc-float-hide]');
    if (!modal || !floatWrap) return;

    var STORAGE_KEY = 'hoop_welcome_modal_state';
    var FOCUS_NS = 'wc_modal_focus';
    var delaySeconds = parseInt(modal.getAttribute('data-wc-delay'), 10);
    if (isNaN(delaySeconds)) delaySeconds = 3;

    var isOpen = false;
    var lastActiveElement = null;
    var hasTrap = window.theme && theme.a11y && typeof theme.a11y.trapFocus === 'function';

    function getState() {
      try { return localStorage.getItem(STORAGE_KEY) || 'initial'; } catch (e) { return 'initial'; }
    }
    function setState(state) {
      try { localStorage.setItem(STORAGE_KEY, state); } catch (e) {}
    }

    function showFloat() {
      floatWrap.classList.add('is-visible');
      [floatOpen, floatHide].forEach(function (el) {
        if (!el) return;
        el.removeAttribute('aria-hidden');
        el.removeAttribute('tabindex');
      });
    }
    function hideFloat() {
      floatWrap.classList.remove('is-visible');
      [floatOpen, floatHide].forEach(function (el) {
        if (!el) return;
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('tabindex', '-1');
      });
    }

    function trapInModal() {
      var focusTarget = modal.querySelector('[data-wc-initial-focus]') ||
        modal.querySelector('button, [href], input, select, textarea');
      if (hasTrap) {
        theme.a11y.trapFocus({ container: modal, elementToFocus: focusTarget, namespace: FOCUS_NS });
      } else if (focusTarget) {
        focusTarget.focus();
      }
    }
    function releaseTrap(fallback) {
      if (hasTrap && typeof theme.a11y.removeTrapFocus === 'function') {
        theme.a11y.removeTrapFocus({ container: modal, namespace: FOCUS_NS });
      }
      var target = fallback && document.contains(fallback) && fallback.getAttribute('aria-hidden') !== 'true'
        ? fallback
        : (lastActiveElement && document.contains(lastActiveElement) && !modal.contains(lastActiveElement) ? lastActiveElement : null);
      if (target) target.focus();
    }

    function getFocusable() {
      var els = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      return [].slice.call(els).filter(function (el) { return el.offsetParent !== null; });
    }

    function onKeydown(event) {
      var key = (event.key || '').toLowerCase();
      if (key === 'escape' || event.keyCode === 27) {
        event.preventDefault();
        minimize();
        return;
      }
      // theme.a11y は first→last(Shift+Tab)のみ。背面をinertにしないため
      // forward/backward 両方向のラップをこのモーダル内で補う。
      if (key === 'tab' || event.keyCode === 9) {
        var f = getFocusable();
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        }
      }
    }

    function open() {
      lastActiveElement = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      modal.removeAttribute('inert');
      hideFloat();
      trapInModal();
      if (!isOpen) {
        document.addEventListener('keydown', onKeydown);
        isOpen = true;
      }
    }

    function minimize() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('inert', '');
      showFloat();
      releaseTrap(floatOpen);
      if (isOpen) {
        document.removeEventListener('keydown', onKeydown);
        isOpen = false;
      }
      setState('minimized');
    }

    function hideAll() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('inert', '');
      hideFloat();
      releaseTrap(null);
      if (isOpen) {
        document.removeEventListener('keydown', onKeydown);
        isOpen = false;
      }
    }

    // 遅延表示中にフロートの非表示ボタンへ Tab 到達しないよう、初期化時点で確実に隠す
    hideFloat();

    // クリックハンドラは状態判定より先に配線（errorでの強制表示時も操作可能にする）
    modal.querySelectorAll('[data-wc-minimize]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        minimize();
      });
    });
    if (floatOpen) {
      floatOpen.addEventListener('click', function () { open(); });
    }
    if (floatHide) {
      floatHide.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setState('hidden');
        hideAll();
      });
    }

    // 直前のフォーム送信がサーバ側エラー（Liquidが window.__wcForceOpen を出力）
    // → エラーを見せるため即時表示。completed にはしない。
    if (window.__wcForceOpen === true) {
      open();
      return;
    }

    var state = getState();
    if (state === 'completed' || state === 'hidden') {
      hideAll();
      return;
    }
    if (state === 'minimized') {
      showFloat();
    } else {
      setTimeout(open, delaySeconds * 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
